<!--
 * @Description:
 * @version:
 * @Author: knight
 * @Date: 2022-01-17 14:52:39
 * @LastEditors: knight
 * @LastEditTime: 2022-01-19 17:34:49
-->
<template>
  <router-view></router-view>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'App',
  created() {
    this.getConfigMenu();
    this.getUserInfo();
  },
  methods: {
    ...mapActions(['getConfigMenu', 'getUserInfo']),
  },
};
</script>

<style></style>
